export enum OrderStepType {
	PRE_FILLING,
	NEW_ORDER,
	NEW_ORDER_WITH_RESERVE,
	RESERVE_ACCOUNT,
	WAITING_RESERVE,
}

export const NAMES_BY_STEP = {
	PANEL_TITLE: {
		[OrderStepType.PRE_FILLING]: 'Создание заявки',
		[OrderStepType.NEW_ORDER]: 'Новая заявка',
		[OrderStepType.NEW_ORDER_WITH_RESERVE]: 'Новая заявка',
		[OrderStepType.RESERVE_ACCOUNT]: 'Резервирование счёта',
		[OrderStepType.WAITING_RESERVE]: 'Резервирование счёта',
	},
	CREATE_BUTTON: {
		[OrderStepType.PRE_FILLING]: 'Создать заявку',
		[OrderStepType.NEW_ORDER]: 'Отправить заявку',
		[OrderStepType.NEW_ORDER_WITH_RESERVE]: {
			true: 'Далее',
			false: 'Отправить заявку',
		},
		[OrderStepType.RESERVE_ACCOUNT]: 'Начать резервирование',
	},
	BYPASS_BUTTON: {
		[OrderStepType.RESERVE_ACCOUNT]: 'Отправить заявку без резервирования',
		[OrderStepType.WAITING_RESERVE]: 'Отправить заявку, не дожидаясь резервирования',
	},
}
